import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.desktop.shared.visit-enter': {
         completePatientDataBeforeStartingVisit: 'Przed rozpoczęciem wizyty uzupełnij wymagane dane pacjenta.',
         consentForMedicalServices: 'Zgoda na udzielenie świadczeń medycznych',
         consentHasBeenEntered: 'Zgoda została wprowadzona.',
         doesPatientConsentToMedicalServicesAndDataProcessing:
            'Czy pacjent wyraża zgodę na udzielanie świadczeń medycznych oraz przetwarzanie danych osobowych?',
         goBackToAppointmentsList: 'Wróć do listy wizyt',
         patientDataHasBeenUpdated: 'Dane pacjenta zostały zaktualizowane.',
         patientIdentifierExpired: 'Identyfikator pacjenta stracił ważność',
         patientOverTwelveMonthsAgeCannotIdentifyWithGuardianPesel:
            'Pacjent powyżej 12. miesiąca życia nie może identyfikować się PESEL-em opiekuna.',
         patientWithGivenPeselAlreadyExists: 'Pacjent o podanym nr PESEL już istnieje.',
         save: 'Zapisz',
         startVisit: 'Rozpocznij wizytę',
         yesTheyAgree: 'Tak, wyraża zgodę',
      },
   },
};

export const translationKeys = createScopedTranslationKeys(translations.pl, '~libs.desktop.shared.visit-enter');
